import { STRIPE_CONFIG } from '../config/stripe';

export interface SubscriptionPlan {
  id: string;
  name: string;
  price: number;
  priceId: string;
  features: string[];
  isPopular?: boolean;
  maxUsers?: number;
  minUsers?: number;
  addOns?: AddOn[];
}

export interface AddOn {
  id: string;
  name: string;
  description: string;
  price: number;
  priceId: string;
  type: 'one-time' | 'recurring';
}

export interface Subscription {
  id: string;
  schoolId: string;
  planId: string;
  stripeSubscriptionId: string;
  stripeCustomerId: string;
  status: 'active' | 'inactive' | 'past_due' | 'canceled' | 'unpaid';
  currentPeriodStart: Date;
  currentPeriodEnd: Date;
  cancelAtPeriodEnd: boolean;
  userCount?: number; // Number of users for user-based pricing
  addOns: string[];
  createdAt: Date;
  updatedAt: Date;
}

export interface PaymentHistory {
  id: string;
  schoolId: string;
  amount: number;
  currency: string;
  status: 'succeeded' | 'failed' | 'pending';
  description: string;
  stripePaymentIntentId: string;
  createdAt: Date;
}

export interface BillingInfo {
  name: string;
  email: string;
  address: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
  };
  phone?: string;
}

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    priceId: '',
    features: [
      'AI-powered personalized dashboard',
      'Shared calendar',
      'Smart messaging with AI summaries',
      'Document hub',
      'Push notifications',
      'Customizable groups/channels',
      'Basic task management',
      'Up to 50 users'
    ],
    maxUsers: 50
  },
  {
    id: 'standard',
    name: 'Standard',
    price: 2,
    priceId: STRIPE_CONFIG.STANDARD_PRICE_ID, // Dynamically uses test or live price ID
    features: [
      'All Free features',
      'AI-driven task automation',
      'Real-time attendance tracking',
      'Advanced analytics',
      'Priority support',
      'Unlimited users'
    ],
    minUsers: 5,
    isPopular: true
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 4,
    priceId: STRIPE_CONFIG.PREMIUM_PRICE_ID, // Dynamically uses test or live price ID
    features: [
      'All Standard features',
      'Custom branding',
      'Advanced reporting',
      'API access',
      'Dedicated account manager',
      'SLA guarantee'
    ],
    minUsers: 5
  }
];

export const ADD_ONS: AddOn[] = [
  {
    id: 'parent_communication',
    name: 'Parent Communication Module',
    description: 'Enable parent-teacher communication features',
    price: 100,
    priceId: 'price_1QRkdLPQ9AdW7pP6oMArBdDg', // You'll need to create this in Stripe Dashboard
    type: 'recurring'
  },
  {
    id: 'docusign',
    name: 'DocuSign Integration',
    description: 'Built-in e-signatures for approvals',
    price: 50,
    priceId: 'price_1QRkdMPQ9AdW7pP6pNBsCeEh', // You'll need to create this in Stripe Dashboard
    type: 'recurring'
  },
  {
    id: 'video_conferencing',
    name: 'Video Conferencing',
    description: 'Integrated video meeting functionality',
    price: 50,
    priceId: 'price_1QRkdNPQ9AdW7pP6qOCtDfFi', // You'll need to create this in Stripe Dashboard
    type: 'recurring'
  }
];